import React from 'react';

const TrustedCompany = () => {
  return (
    <section className="trusted-company" id="values">
      <div className="container">
        <div className="row">
          <div className="col-xl-6">
            <div className="trusted-company__left">
              <div className="trusted-company__img wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms">
                <img src="https://images.pexels.com/photos/6191877/pexels-photo-6191877.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="A group of diverse people working together at a table." />
                <div className="trusted-company__solution">
                  <p className="trusted-company__solution-content">A community built on trust and respect.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="trusted-company__right">
              <div className="section-title text-left">
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">What Drives Us</span>
                  <div className="section-title-shape">
                    <img src="assets/images/shapes/section-title-shape.png" alt="decorative shape" />
                  </div>
                </div>
                <h2 className="section-title__title">Our Core Values</h2>
              </div>
              <p className="trusted-company__text-1">At Create & Commune, our values are the heartbeat of our community.</p>
              <p className="trusted-company__text-2">They shape every interaction, program, and opportunity we create, ensuring a supportive and empowering ecosystem for all creatives.</p>
              <div className="trusted-company__points-box">
                <ul className="list-unstyled trusted-company__points">
                  <li>
                    <div className="icon"><span className="icon-check"></span></div>
                    <div className="text"><h6>Creativity</h6><p>We value originality, expression, and the fearless pursuit of ideas.</p></div>
                  </li>
                  <li>
                    <div className="icon"><span className="icon-check"></span></div>
                    <div className="text"><h6>Collaboration</h6><p>We believe in the power of collective work to elevate every individual.</p></div>
                  </li>
                  <li>
                    <div className="icon"><span className="icon-check"></span></div>
                    <div className="text"><h6>Growth</h6><p>Personal and professional development is at the heart of everything we do.</p></div>
                  </li>
                  {/*  </ul>
                <ul className="list-unstyled trusted-company__points trusted-company__points-two"> */}
                  <li>
                    <div className="icon"><span className="icon-check"></span></div>
                    <div className="text"><h6>Inclusivity</h6><p>C2 welcomes all creatives, regardless of background, identity, or discipline.</p></div>
                  </li>
                  <li>
                    <div className="icon"><span className="icon-check"></span></div>
                    <div className="text"><h6>Empowerment</h6><p>We help creatives turn passion into sustainable, impactful careers.</p></div>
                  </li>
                  <li>
                    <div className="icon"><span className="icon-check"></span></div>
                    <div className="text"><h6>Respect</h6><p>We foster a safe, supportive, and respectful environment.</p></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedCompany;
